import React from "react";

const AtHomeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="128px"
    viewBox="0 0 24 24"
    width="128px"
    fill="#000000"
  >
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path d="M18.98 17H2v2h20v-2zM21 16c-.27-4.07-3.25-7.4-7.16-8.21.1-.24.16-.51.16-.79 0-1.1-.9-2-2-2s-2 .9-2 2c0 .28.06.55.16.79C6.25 8.6 3.27 11.93 3 16h18zm-9-6.42c2.95 0 5.47 1.83 6.5 4.41h-13c1.03-2.58 3.55-4.41 6.5-4.41z" />
  </svg>
);

export default AtHomeIcon;
